"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
var Result = /** @class */ (function () {
    function Result(isSuccess, value, error) {
        if (isSuccess && !!error) {
            throw new Error('Successful result cannot contain an error');
        }
        if (!isSuccess && !!value) {
            throw new Error('Failed result cannot contain value');
        }
        this.isSuccess = isSuccess;
        this.isFailure = !isSuccess;
        this.value = value;
        this.error = error;
    }
    Result.prototype.getError = function () {
        if (this.isSuccess) {
            throw new Error('Successful result does not contain an error');
        }
        return this.error;
    };
    Result.prototype.getValue = function () {
        if (this.isFailure) {
            throw new Error('Failed result does not contain value');
        }
        return this.value;
    };
    Result.ok = function (value) {
        return new Result(true, value, undefined);
    };
    Result.fail = function (error) {
        return new Result(false, undefined, error);
    };
    return Result;
}());
exports.Result = Result;
//# sourceMappingURL=Result.js.map